module.exports = __webpack_public_path__ + "img/wx.6838e7b0.png";